/*
 * Authors: mariushirjanu
 * Created: 30/06/2020
 * Upgraded: 28/02/2023
 */
import { Component, OnInit, Input } from '@angular/core';
import { PriceCartService } from './price-cart.service';
import { Subscription } from 'rxjs';
import { GaEventService, IGAEvent } from '../../../shared/services/ga-event.service';
import { EVENT_ORDER_CART_COUNT_CHANGED } from '../../../shared/app-events';

@Component({
  selector: 'cart-popup',
  template: `
    <div class="cart-dropdown">
      <div class="d-md-none d-lg-none d-sm-block">
        <button class="btn btn-default cart-dropdown-button" type="button" [uiSref]="cartTab">
          <i class="fa fa-shopping-cart"></i>
          {{ cartCount }}
        </button>
      </div>
      <div class="dropdown d-sm-none d-md-block" dropdown (isOpenChange)="toggled()">
        <button class="btn btn-default cart-dropdown-button" type="button" dropdownToggle>
          <i class="fa fa-shopping-cart"></i>
          {{ cartCount }}
        </button>
        <div class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu>
          <div class="dropdown-cart" maxHeight [open]="open" (click)="$event.stopPropagation();">
            <cart [orderId]="orderId" [isPopupCart]="open"></cart>
          </div>
          <button type="button" class="btn-close close-absolute">
            <span class="visually-hidden">Close</span>
          </button>
        </div>
      </div>
    </div>
  `
})
export class CartPopupComponent implements OnInit {
  @Input() public orderId:number;
  public cartTab:string;
  public cartCount:number = 0;
  public open:boolean;
  private eventHandler:Subscription;

  constructor(
    private priceCartService:PriceCartService,
    private eventService:GaEventService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.start();
    this.listen();
  }

  private start():void {
    this.cartTab = this.priceCartService.cartTab;
    this.cartCount = this.priceCartService.cartCount;
  }

  private listen():void {
    this.eventHandler = this.eventService.events.subscribe((event: IGAEvent) => {
      if(event.name === EVENT_ORDER_CART_COUNT_CHANGED) {
        this.cartCount = event.data;
      }
    });
  }

  public toggled():void {
    // this will trigger onChanges when the popup is open to reload prices
    this.open = !this.open;
  }

  public ngOnDestroy(): void {
    this.eventHandler.unsubscribe();
  }
}